import React, { useState, useEffect, Fragment } from "react";
import { useHistory } from "react-router-dom";
import {
	API_URL,
	scroll,
	getValFromLS,
	setValToLS,
	isValidEmail,
} from "../helpers";
import Hdg from "../components/Hdg";
import Alert from "../components/Alert";
import Input from "../components/Input";
import Checkbox from "../components/Checkbox";
import Checkboxes from "../components/Checkboxes";
import Radios from "../components/Radios/index";
import Msg from "../components/Msg";
import Submit from "../components/Submit";

const CharityRegContact = () => {
	const [errors, setErrors] = useState([]);
	const [names, setNames] = useState({
		id: "0",
		cats: [],
	});
	const [msg, setMsg] = useState({});
	const [alert, setAlert] = useState({
		type: "working",
		text: "",
	});

	const history = useHistory();

	useEffect(() => {
		scroll();
		init(getValFromLS("crId") || "0");
	}, []);

	const init = async (id) => {
		const url = new URL(`${API_URL}/crContactInit`);
		const params = {
			id,
		};
		url.search = new URLSearchParams(params);

		try {
			const response = await fetch(url, {
				method: "GET",
				cache: "no-store",
			});
			const json = await response.json();
			if (json) {
				setNames({ ...json });
				setAlert({});
				if (json.resp === 0 && getValFromLS("crId")) {
					setValToLS("crId", "");
				}
			}
		} catch (error) {
			setAlert({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	const handleUpdate = (name, value) => {
		setNames((names) => ({ ...names, [name]: value ? value : "" }));
	};

	const handleCheckboxes = (name, checked, val) => {
		let newValue = "";
		if (checked) {
			newValue = val;
		}
		setNames((names) => ({ ...names, [name]: newValue }));
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setErrors([]);
		setMsg({
			type: "working",
			text: "",
		});

		const url = new URL(`${API_URL}/crContact`);
		let data = new FormData();
		Object.entries(names).forEach(([key, value]) => {
			if (key === "textOptIn" || key === "textOptIn2") {
				data.append(key, value ? "1" : "0");
			} else if (key === "cats") {
			} else {
				data.append(key, value);
			}
		});

		try {
			const response = await fetch(url, {
				method: "POST",
				body: data,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				setValToLS("crId", json.id);
				history.push("/registration");
			} else {
				setErrors(json.fields);
				setMsg({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setMsg({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	return (
		<div id="full-column">
			<Hdg section="Registration" />
			<Fragment>
				{alert.type ? (
					<Alert data={alert} />
				) : (
					<Fragment>
						<h3>
							<i className="fa fa-user-o" /> &nbsp;Contact Information
						</h3>
						<p>
							Please fill out this form completely with your Charity’s Chair
							(main contact) and Vice Chair (secondary contact) information.
							Should you have any questions, please contact{" "}
							<a href="mailto:stephanie@valerotexasopen.com">
								Stephanie@ValeroTexasOpen.com
							</a>{" "}
							or at 210.345.3839.
						</p>

						<form
							method="post"
							action="/"
							onSubmit={(e) => handleSubmit(e)}
							className="well"
						>
							<h3 style={{ marginTop: "0" }}>Chair (Main Contact)</h3>

							<div className="form-group">
								<Input
									name="fname"
									label="First Name"
									reqd={true}
									value={names.fname || ""}
									update={handleUpdate}
									errors={errors}
								/>
								<Input
									name="lname"
									label="Last Name"
									reqd={true}
									value={names.lname || ""}
									update={handleUpdate}
									errors={errors}
								/>
							</div>

							<div className="form-group">
								<Input
									name="email"
									label="Email"
									reqd={true}
									value={names.email || ""}
									update={handleUpdate}
									errors={errors}
								/>
								<Input
									name="phone"
									label="Phone"
									reqd={true}
									value={names.phone || ""}
									update={handleUpdate}
									errors={errors}
								/>
							</div>

							<div className="form-group checkbox" style={{ marginTop: "5px" }}>
								<Checkbox
									name="textOptIn"
									label="Check to opt-in for receiving VIP reminders sent directly to your phone"
									checked={names.textOptIn || false}
									click={handleUpdate}
								/>
							</div>

							<div className={!names.textOptIn ? "hidden" : ""}>
								<div className="form-group">
									<Input
										name="textCell"
										label="Cell Number"
										reqd={true}
										value={names.textCell || ""}
										update={handleUpdate}
										errors={errors}
										note="Please provide a US-based (+1) cell phone number to enroll in this added feature."
									/>
									<div className="empty" />
								</div>
							</div>

							<div className="form-group radios">
								<Radios
									label="Please mail all communication throughout the season to:"
									reqd={true}
									data={names.cats}
									value={names.preferredMail || ""}
									click={handleUpdate}
								/>
							</div>

							<div
								className={names.preferredMail === "home" ? "" : "hidden"}
								style={{ marginTop: "10px", marginBottom: "25px" }}
							>
								<div className="form-group">
									<Input
										name="homeAddress"
										label="Home Mailing Address"
										reqd={true}
										value={names.homeAddress || ""}
										update={handleUpdate}
										errors={errors}
									/>
									<Input
										name="homePhone"
										label="Home/Cell Phone"
										reqd={true}
										value={names.homePhone || ""}
										update={handleUpdate}
										errors={errors}
									/>
								</div>
								<div className="form-group three">
									<Input
										name="homeCity"
										label="City"
										reqd={true}
										value={names.homeCity || ""}
										update={handleUpdate}
										errors={errors}
									/>
									<Input
										name="homeSt"
										label="State (2-letter)"
										reqd={true}
										value={names.homeSt || ""}
										update={handleUpdate}
										errors={errors}
									/>
									<Input
										name="homeZip"
										label="Zip Code"
										reqd={true}
										value={names.homeZip || ""}
										update={handleUpdate}
										errors={errors}
									/>
								</div>
							</div>

							<h3 style={{ marginTop: "15px" }}>
								Vice Chair (Secondary Contact)
							</h3>

							<div className="form-group">
								<Input
									name="fname2"
									label="First Name"
									reqd={false}
									value={names.fname2 || ""}
									update={handleUpdate}
									errors={errors}
									autocomplete="off"
								/>
								<Input
									name="lname2"
									label="Last Name"
									reqd={false}
									value={names.lname2 || ""}
									update={handleUpdate}
									errors={errors}
									autocomplete="off"
								/>
							</div>
							<div className="form-group">
								<Input
									name="email2"
									label="Email"
									reqd={false}
									value={names.email2 || ""}
									update={handleUpdate}
									errors={errors}
									autocomplete="off"
								/>
								<Input
									name="phone2"
									label="Phone"
									reqd={false}
									value={names.phone2 || ""}
									update={handleUpdate}
									errors={errors}
									autocomplete="off"
								/>
							</div>

							<div className="form-group checkbox" style={{ marginTop: "5px" }}>
								<Checkbox
									name="textOptIn2"
									label="Check to opt-in for receiving VIP reminders sent directly to your phone"
									checked={names.textOptIn2 || false}
									click={handleUpdate}
								/>
							</div>

							<div className={!names.textOptIn2 ? "hidden" : ""}>
								<div className="form-group">
									<Input
										name="textCell2"
										label="Cell Number"
										reqd={true}
										value={names.textCell2 || ""}
										update={handleUpdate}
										errors={errors}
										autocomplete="off"
										note="Please provide a US-based (+1) cell phone number to enroll in this added feature."
									/>
									<div className="empty" />
								</div>
							</div>

							<h3 style={{ marginTop: "20px", marginBottom: "0" }}>
								Additional Dashboard Access
							</h3>

							<p style={{ marginTop: "7.5px" }}>
								Would you like to have one (1) additional person have access to
								your charity dashboard to pull fundraising reports? If so,
								please provide the following info:
							</p>

							<div className="form-group">
								<Input
									name="fname3"
									label="First Name"
									reqd={false}
									value={names.fname3 || ""}
									update={handleUpdate}
									errors={errors}
									autocomplete="off"
								/>
								<Input
									name="lname3"
									label="Last Name"
									reqd={false}
									value={names.lname3 || ""}
									update={handleUpdate}
									errors={errors}
									autocomplete="off"
								/>
							</div>
							<div className="form-group" style={{ marginBottom: "30px" }}>
								<Input
									name="email3"
									label="Email"
									reqd={false}
									value={names.email3 || ""}
									update={handleUpdate}
									errors={errors}
									autocomplete="off"
								/>

								<div className="empty" />
							</div>

							<h3 style={{ marginTop: "20px", marginBottom: "0" }}>
								Monthly Fundraising Report
							</h3>

							<p style={{ marginTop: "7.5px", marginBottom: "0" }}>
								Would you like to be emailed a fundraising report on the first
								of each month containing the previous month’s donations?
							</p>

							<div className="form-group radios" style={{ marginTop: "10px" }}>
								<Checkboxes
									label="If so, please indicate up to 3 contacts to receive the notification."
									reqd={false}
									data={[
										{
											name: "notify1",
											val: "email",
											label: `Chair (${names.email})`,
											hide: !isValidEmail(names.email),
										},
										{
											name: "notify2",
											val: "email2",
											label: `Vice Chair (${names.email2})`,
											hide: !isValidEmail(names.email2),
										},
										{
											name: "notify3",
											val: "email3",
											label: `Additional (${names.email3})`,
											hide: !isValidEmail(names.email3),
										},
									]}
									values={[
										names.notify1 || "",
										names.notify2 || "",
										names.notify3 || "",
									]}
									click={handleCheckboxes}
								/>
							</div>

							<div className="msg-submit">
								{msg.type && <Msg data={msg} />}

								<div
									className={
										msg.type === "working" || msg.type === "success"
											? "hidden"
											: "submit-container"
									}
								>
									<Submit
										path="/registration"
										left="Back"
										submit="Submit Contact Information"
									/>
								</div>
							</div>
						</form>
					</Fragment>
				)}
			</Fragment>
		</div>
	);
};

export default CharityRegContact;
